export default __webpack_public_path__ + "static/media/za.35fc70ec.svg";